import vue from "vue";

export default {
    SET_ITEMS: (state, items) => {
        state.items = items;
    },
}